<template>
  <div style="
  width: 830px;
  margin: 0px auto;
  padding: 10px 29px;
  background: #eef0f2;
  border: 3px solid #c33c3c96;
  border-radius: 11px;" class="oplatakontragent">
    <div class="row">
      <div class="col-md-6">
        <h4 style="font-weight: bold;color:#3d464c;">
          {{ $t($route.name) }}
          <span v-if="$route.params.id != undefined">№{{ $route.params.id }}</span> <br>
          {{ Dates(datas.created_at) }}
        </h4>
        <button type="button" v-if="$route.params.id!=undefined && settedrule.change==true" @click="Change()"
          class="btn btn-primary change">{{$t('Ўзгартириш')}}</button>
      </div>
      <div class="col-md-6 end" style="padding: 14px 23px;">
        <button type="button" class="mybtn btn saved" @click="Savedokument()" :disabled="changedisabled">
          {{ $t("Сақлаш ва беркитиш") }} <sup>crl+enter</sup>
        </button>
        <router-link class="btn btn-danger" :to="{ path: '/convertion/index' }">
          <button type="button" class="closebutton">
            <b-icon icon="x-lg"></b-icon>
          </button>
        </router-link>
      </div>
    </div>
    <div class="row">
      <!-- sklad -->
      <div class="col-md-9 topheader">
        <span>
          <label>Склад</label>
          <v-select :clearable="false" class="form-control-sm required md-input" :options="skladlist"
            :disabled="changedisabled" v-model="datas.sklad_id" :reduce="name => name.id" label="name">
            <template #search="{ attributes, events }">
              <input class="vs__search" v-bind="attributes" v-on="events" aria-activedescendant="null" />
            </template>
            <template v-slot:no-options="{ search, searching }">
              <template v-if="searching">
                <em><b>{{ search }}</b></em>
                {{ $t("бўйича маьлумот йўқ") }}
              </template>
              <em style="opacity: 0.5" v-else>{{ $t("Маьлумот йўқ") }}</em>
            </template>
          </v-select>
        </span>
      </div>
      <div class="col-md-3 topheader">
        <span>
          <label>Курс</label>
          <input type="text"  :disabled="changedisabled"  v-model="datas.dollar_rate"  @change="Summachange()"></span>
      </div>
      <!-- tip -->
      <div class="col-md-6">
        <span class="backblock" style="height: 180px;">
          {{$t("Расход")}}
        <!-- tipoplata -->
        <div class="col-md-12 topheader">
          <span>
            <label for="">{{ $t("Тўлов тури") }}</label>
            <v-select :disabled="changedisabled" :clearable="false" @input="Summachange()"
              class="form-control-sm required md-input" :options="paytypelist" v-model="datas.pay_type_from_id"
              :reduce="name => name.id" label="name">
              <template #list-footer>
                <li style="text-align: center;font-weight:bold;">
                  f4 {{ $t("умумий рўйхат") }}
                </li>
              </template>
              <template #search="{ attributes, events }">
                <input ref="focused" class="vs__search" v-bind="attributes" v-on="events" />
                <button type="button" class="modallist" v-b-modal.modal-paytypelist>
                  <b-icon icon="three-dots"></b-icon>
                </button>
              </template>
              <template v-slot:no-options="{ search, searching }">
                <template v-if="searching">
                  <em><b>{{ search }}</b></em>
                  {{ $t("бўйича маьлумот йўқ") }}
                </template>
                <em style="opacity: 0.5" v-else>{{ $t("Маьлумот йўқ") }}</em>
              </template>
            </v-select>
          </span>
        </div>
        <!-- summa -->
        <div class="col-md-12 topheader">
          <span>
            <label>Сумма</label>
            <vue-numeric :disabled="changedisabled" v-model="datas.summa" separator="space" class="table-input"
              @change="Summachange()" v-bind:precision="2">
            </vue-numeric>
          </span>
        </div>
        </span>
      </div>
      <div class="col-md-6">
        <span class="backblock" style="height: 180px;">
          {{$t("Кирим")}}
        <!-- tipoplata kassa -->
        <div class="col-md-12 topheader">
          <span>
            <label for="">{{ $t("Тўлов тури") }} Касса</label>
            <v-select :disabled="changedisabled" :clearable="false" class="form-control-sm required md-input"
              :options="paytypelist" @input="Summachange()" v-model="datas.pay_type_of_id" :reduce="name => name.id"
              label="name">
              <template #list-footer>
                <li style="text-align: center;font-weight:bold;">
                  f4 {{ $t("умумий рўйхат") }}
                </li>
              </template>
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button type="button" class="modallist" v-b-modal.modal-paytypelist>
                  <b-icon icon="three-dots"></b-icon>
                </button>
              </template>
              <template v-slot:no-options="{ search, searching }">
                <template v-if="searching">
                  <em><b>{{ search }}</b></em>
                  {{ $t("бўйича маьлумот йўқ") }}
                </template>
                <em style="opacity: 0.5" v-else>{{ $t("Маьлумот йўқ") }}</em>
              </template>
            </v-select>
          </span>
        </div>
        <!-- kassa summa -->
        <div class="col-md-12 topheader">
          <span>
            <label>Сумма</label>
            <vue-numeric @change="ChangeKassasumma()" :disabled="changedisabled" v-model="datas.summa_convertion" separator="space" class="table-input"
              v-bind:precision="2">
            </vue-numeric>
          </span>
        </div>
        </span>
      </div>
      <div class="col-md-12 topheader">
        <span class="backblock" style="height: 150px;">
          Комментарий
        <span >
          <textarea class="table-input" v-model="datas.comment" cols="30" rows="5"></textarea>
        </span>
        </span>
      </div>
      <div class="row" style="margin: 0!important;">
      </div>
    </div>
  </div>
  <!-- <div class="col-md-6"> -->
  <!-- </div> -->
  <!-- </div>
  </div> -->
</template>
<script>
  import $ from "jquery";
  import { print } from "../../components/mixins/print.js";
  export default {
    mixins: [print],
    name: "ChiqimForm",
    data() {
      return {
        typelist: [
          { id: false, name: this.$t("Расход") },
          { id: true, name: this.$t("Кирим") }
        ],
        sklad: "",
        paytype: "",
        kontragent: "",
        skladlist: [],
        paytypelist: [],
        pay_date: 0,
        kontragentlist: []
      };
    },
    props: ["datas"],
    created() {
      let self = this;
      self.$root.$refs.convertion = self;
      self.$root.$on("skladone", function (getdata) {
        self.sklad = getdata;
      });
      self.$root.$on("skladall", function (getdata) {
        self.skladlist = getdata;
      });
      self.$root.$on("paytypeone", function (getdata) {
        self.paytype = getdata;
      });
      self.$root.$on("paytypeall", function (getdata) {
        self.paytypelist = getdata;
      });
      self.$root.$on("kontragentone", function (getdata) {
        self.kontragent = getdata;
      });
      self.$root.$on("kontragentall", function (getdata) {
        self.kontragentlist = getdata;
      });
    },
    mounted: function () {
      let self = this;
      self.Focus();
      self.SetRule('/convertion/index');
    },
    methods: {
      Summachange() {
        if (this.datas.pay_type_from_id == 3) {
          if (this.datas.pay_type_of_id == 3) {
            this.datas.summa_convertion = this.datas.summa;
          } else {
            this.datas.summa_convertion = this.datas.summa * this.datas.dollar_rate;
          }
        } else {
          if (this.datas.pay_type_of_id != 3) {
            this.datas.summa_convertion = this.datas.summa;
          } else {
            this.datas.summa_convertion = this.datas.summa / this.datas.dollar_rate;
          }
        }
      },
      ChangeKassasumma() {
        //   if (this.datas.pay_type_from_id == 3) {
        //   if (this.datas.pay_type_of_id == 3) {
        //     this.datas.summa = this.datas.summa_convertion;
        //   } else {
        //     this.datas.summa = this.datas.summa_convertion/this.datas.dollar_rate;
        //   }
        // } else {
        //   if (this.datas.pay_type_of_id != 3) {
        //     this.datas.summa = this.datas.summa_convertion;
        //   } else {
        //     this.datas.summa = this.datas.summa_convertion * this.datas.dollar_rate;
        //   }
        // }
      },
      Focus() {
        this.$refs.focused.focus();
      },
      Selectkontragent(index) {
        this.$root.$emit("tableselect", index);
      },
      Selectpaytype(index) {
        this.$root.$emit("tableselect", index);
      },
      Savedokument() {
        let self = this;
        // if (self.rule.open == true) {
          if (this.$route.path == "/convertion/create") {
            var methods = "post";
            var action = "api/v1/convertion";
          } else {
            var methods = "patch";
            var action = "api/v1/convertion/id/" + self.$route.params.id;
          }
          axios({
            method: methods,
            url: action,
            data: self.datas
          }).then(function (response) {
            self.$store.state.saved = null;
            self.$router.push({ name: "Конверсия" });
          });
        // } else {
        //   self.$store.state.errors = self.$t('Sizdan bunday xuquq mavjud emas');
        // }
      }
    }
  };
</script>

<style lang="scss" scoped>
  .oplatakontragent .topheader>span{
    border: 2px solid rgb(165, 165, 227);
  }
  .md-dialog .md-dialog-container {
    max-width: 768px;
  }
</style>